import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const OnlyDesktop = styled.div`
  background-color: var(--color-bg-body);
  bottom: 0;
  display: none;
  height: 100vh;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100;

  ${DEVICE.tablet.mid} {
    display: block;
  }
`;

const OnlyDesktopBody = styled.div`
  margin-top: 40px;
  text-align: center;
`;

export { OnlyDesktop, OnlyDesktopBody };
